// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Barbados from '../_raw/flag/icon_flag_barbados.png';

export default () => <img src={Barbados} alt="Barbados" />;
